import React from 'react';

import ModalMatchesContent from './components/modal-matches-content';
import ModalTeamContent from './components/modal-team-content';
import PlayOffStagesGrid from './components/play-off-stages-grid';
import StandingsGroup from './components/standings-group';
import withSideModal from './hocs/with-side-modal';

import styles from './desktop-container.module.css';

const getChunkLists = (list, chunkSize) => {
  if (!list?.length) {
    return [[], []];
  }

  const newList = [...list];

  return [...Array(Math.ceil(newList.length / chunkSize))].map(() => newList.splice(0, chunkSize));
};

function EuroDesktopContainer({
  groups,
  playOffStages,
  toggleSideModal,
  chunkSize = 1
}) {
  const [firstListGroups, secondListGroups] = getChunkLists(groups, chunkSize);

  const onTeamClick = ({
    id: teamId,
    countryCode,
    teamName
  }) => toggleSideModal({
    isOpen: true,
    renderContent: () => <ModalTeamContent teamId={teamId} countryCode={countryCode} teamName={teamName} />
  });

  const onScheduleClick = ({id, name}) => toggleSideModal({
    isOpen: true,
    renderContent: () => <ModalMatchesContent id={id} name={name} onTeamClick={onTeamClick} />
  });

  return (
    <div className={styles.root}>
      <div>
        {firstListGroups.map(({name, teams, id}) => (
          <StandingsGroup
            key={id}
            id={id}
            name={name}
            teams={teams}
            className={styles.group}
            onScheduleClick={() => onScheduleClick({id, name})}
            onTeamClick={onTeamClick}
          />
        ))}
      </div>
      <div className={styles.middleBlock}>
        <PlayOffStagesGrid list={[...playOffStages].reverse()} />
      </div>
      <div>
        {secondListGroups.map(({name, teams, id}) => (
          <StandingsGroup
            key={id}
            id={id}
            name={name}
            teams={teams}
            className={styles.group}
            onScheduleClick={() => onScheduleClick({id, name})}
            onTeamClick={onTeamClick}
          />
        ))}
      </div>
    </div>
  );
}

export default withSideModal(EuroDesktopContainer);
